import { render, staticRenderFns } from "./CustomerProfileCount.vue?vue&type=template&id=323b35f8"
import script from "./CustomerProfileCount.vue?vue&type=script&lang=js"
export * from "./CustomerProfileCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports